/*
 * Buttonology: auto-select the first available option when a colour change leaves the current
 * size unavailable. Loaded site-wide from layout/theme.liquid (it used to be a {% javascript %}
 * block in snippets/variant-main-picker.liquid, which Atelier 4.x only loads where that snippet
 * renders on first load, so the quick-add pop-up never got it).
 */
/**
 * Auto-select first available variant option on color change.
 *
 * When a customer picks a color whose current size doesn't exist, the
 * Section Rendering API swaps in new HTML. This script immediately
 * detects the unavailable checked radio and clicks the first available
 * one — firing as fast as possible (no rAF delay) to minimise any
 * intermediate state.
 *
 * A subtle CSS crossfade on the product media makes the image swap
 * look smooth and intentional rather than jarring.
 */
(function initAutoSelectAvailable() {
  'use strict';

  /**
   * Inject a smooth crossfade transition on product media images.
   * This makes any image swap (including the brief intermediate one)
   * look like an intentional fade rather than a harsh flash.
   */
  function injectTransitionStyle() {
    if (document.getElementById('variant-media-crossfade')) return;
    var style = document.createElement('style');
    style.id = 'variant-media-crossfade';
    style.textContent = [
      '.product-information__media img,',
      '.product-information__media slideshow-slides,',
      '.product-information__media slideshow-component {',
      '  transition: opacity 0.25s ease-in-out !important;',
      '}'
    ].join('\n');
    document.head.appendChild(style);
  }

  /**
   * Check all fieldsets inside a picker. If any checked radio is
   * unavailable, click the first available one.
   */
  function autoSelectFirstAvailable(variantPicker) {
    var fieldsets = variantPicker.querySelectorAll('fieldset[data-fieldset-index]');

    fieldsets.forEach(function (fieldset) {
      var checked = fieldset.querySelector('input[type="radio"]:checked');
      if (!checked) return;
      if (checked.getAttribute('data-option-available') !== 'false') return;

      var firstAvailable = fieldset.querySelector(
        'input[type="radio"][data-option-available="true"]:not(:checked)'
      );
      if (!firstAvailable) return;

      firstAvailable.click();
    });
  }

  function observePicker(picker) {
    var observer = new MutationObserver(function () {
      /*
       * Fire immediately — no requestAnimationFrame delay.
       * The faster we click the correct size, the shorter any
       * intermediate wrong-image state lasts.
       */
      autoSelectFirstAvailable(picker);
    });

    observer.observe(picker, { childList: true, subtree: true });
  }

  var observed = new WeakSet();

  function observeOnce(picker) {
    if (observed.has(picker)) return;
    observed.add(picker);
    observePicker(picker);
    autoSelectFirstAvailable(picker);
  }

  function init() {
    injectTransitionStyle();
    document.querySelectorAll('variant-picker').forEach(observeOnce);

    /*
     * Pickers that arrive after page load (the quick-add pop-up on collection,
     * search and home pages) are picked up here as well.
     */
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('variant-picker')) observeOnce(node);
          if (node.querySelectorAll) node.querySelectorAll('variant-picker').forEach(observeOnce);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
